<template>
  <div class="refill-overlay">
    <p class="small">
      A balance dipping below a set Refill Threshold will trigger an additional
      Refill Amount added to the card.
    </p>
    <div v-if="card.Holder">
      <label>Card Holder</label>
      <br />
      {{ typeof card.Holder === 'object' ? card.Holder.Name : card.Holder }}
    </div>
    <br />
    <ed-input type="money" amount v-model="RefillSettings.RefillThreshold" field-label="Refill Threshold" />
    <ed-input type="money" amount v-model="RefillSettings.RefillAmount" field-label="Refill Amount" />
  </div>
</template>

<script>

import { EventBus } from '@/event-bus'

export default {

  created() {
    this.getRefillSettings()
  },

  methods: {
    async doRefill(showModal) {
      if (this.card.Id) {
        try {
          const response = await this.api.patch(`evedpaycards/${this.card.Id}/refill-settings`, {
            RefillSettings: this.RefillSettings
          })
          if (response.status === 200) {
            showModal.showModal = false
            EventBus.$emit('refill', this.card.Id)
          } else {
            console.log('Failed to refill')
          }
        } catch (error) {
          console.log(error)
        }
      }
    },

    async getRefillSettings() {
      if (this.card.Id) {
        try {
          const response = await this.api.get(`evedpaycards/${this.card.Id}/refill-settings`)
          if (response.status === 200) {
            this.RefillSettings = response.data
          }
        } catch (error) {
          console.log(error)
        }
      }
    }
  },

  props: {
    card: Object
  },

  data() {
    return {
      RefillSettings: { RefillAmount: null, RefillThreshold: null }
    }
  }
}
</script>

<style lang="scss" scoped>
  .refill-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/CardRefill.vue